import { useAnalysisStore } from '@modules/analysis/store/analysisStore';
import { useMemo } from 'react';
import useGetSourceDetailsMap from 'v2/core/repository/edge-server/source-details';
import { getQuantifyStateFromEQLProperties } from '../utils/getQuantifyStateFromEQLProperties';

export const useGetQuantifyStateFromAnalysisStore = () => {
  const createdAt = useAnalysisStore(({ createdAt }) => createdAt);
  const quantifyMetadata = useAnalysisStore(
    ({ metadataV2 }) => metadataV2?.quantify,
  );
  const eqlProperties = useAnalysisStore(
    ({ context }) => context.eql?.properties,
  );
  const legacyQuantifyMetadata = useAnalysisStore(({ metadata }) => metadata);

  const { data: sourceDetailsMap } = useGetSourceDetailsMap();

  const stateFromEQLProperties = useMemo(() => {
    if (!eqlProperties || !sourceDetailsMap) {
      return undefined;
    }
    return getQuantifyStateFromEQLProperties({
      properties: eqlProperties,
      sourceDetailsMap,
      quantifyMetadata,
      legacyQuantifyMetadata,
      createdAt,
    });
  }, [
    eqlProperties,
    sourceDetailsMap,
    quantifyMetadata,
    legacyQuantifyMetadata,
    createdAt,
  ]);

  return stateFromEQLProperties;
};
